import React from 'react';
import PartnerCard from './components/PartnerCard';
import { Skeleton } from '@/components/ui/skeleton';
import type { Partner } from '@/types/xdao';

type XDaoContentProps = {
    partners?: Partner[];
    isLoading?: boolean;
    isError?: boolean;
    errorMessage?: string;
    onRetry?: () => void;
    useClientRouterLinks?: boolean;
};

export function XDaoContent({
    partners,
    isLoading = false,
    isError = false,
    errorMessage,
    onRetry,
    useClientRouterLinks = true,
}: XDaoContentProps) {
    return (
        <div className="flex flex-col px-8 py-12 gap-10">
            <p className='font-tiny5 text-white text-5xl'>
                Explore Project
            </p>
            <div className="grid grid-cols-[repeat(auto-fill,minmax(12.75rem,1fr))] md:grid-cols-[repeat(auto-fill,minmax(27.625rem,1fr))] gap-6">
                {isLoading ? (
                    Array.from({ length: 3 }).map((_, index) => (
                        <div key={index.toString()}>
                            <Skeleton className="min-w-[12.75rem] h-[12rem] bg-[#0A094D] rounded-none rounded-t-2xl md:min-w-[27.625rem]"/>
                            <Skeleton className="min-w-[12.75rem] h-[15rem] flex flex-col p-[1.25rem] bg-[#171921] rounded-none rounded-b-2xl md:min-w-[27.625rem]">
                                <Skeleton className="w-52 h-12 bg-[#757575] mb-5"/>
                                <Skeleton className="w-full h-full bg-[#757575]"/>
                            </Skeleton>
                        </div>
                    ))
                ) : isError ? (
                    <div className="col-span-full flex flex-col items-center justify-center gap-4 py-12">
                        <p className="text-white text-lg">Failed to load projects</p>
                        <p className="text-gray-400 text-sm">{errorMessage || 'An error occurred'}</p>
                        {onRetry && (
                            <button
                                onClick={onRetry}
                                className="px-6 py-2 bg-[#0A094D] hover:bg-[#1A1966] text-white rounded-lg transition-colors"
                            >
                                Retry
                            </button>
                        )}
                    </div>
                ) : (
                    partners?.map((partner) => (
                        <PartnerCard
                            key={partner.id}
                            partner={partner}
                            useClientRouterLink={useClientRouterLinks}
                        />
                    ))
                )}
            </div>
        </div>
    );
}
